import styled, { css } from 'styled-components';
import { QuillToolbarStyles } from './QuillToolbarStyles';
import { scrollbarStyle } from '@styles/variants/scrollbar';

const typeContainerMap = {
  editor: css`
    min-height: 120px;
  `,
  input: css`
    min-height: 30px;
  `,
};

const hiddenEditor = css`
  position: absolute;
  top: -9999px;
  left: -9999px;
  height: 1px;
`;

export const QuillEditorContainer = styled.div<{
  height?: number | string;
  maxHeight?: number;
  minHeight?: number;
  type?: 'editor' | 'input';
  lineHeight?: number;
  isHtmlMode?: boolean;
}>`
  display: flex;
  border: none;
  width: 100%;
  flex-direction: column;

  ${scrollbarStyle}
  overflow-y :unset; // 이게 있으면, 이모티콘 등이 안보이고 스크롤 처리 됨.

  .ql-container {
    border: transparent !important;
    border-top: none !important;
    height: 100%;
    position: relative;
    font-family: var(--defaultFontFamily) !important;
    ${({ type }) => type && typeContainerMap[type]}
    max-height: ${({ maxHeight }) => `${maxHeight}px` || '100%'};
    min-height: ${({ minHeight }) => `${minHeight}px` || '100%'};
  }

  .ql-editor {
    max-height: ${({ maxHeight }) => `${maxHeight}px` || '100%'};
    min-height: ${({ minHeight }) => `${minHeight}px` || '100%'};
    p {
      line-height: ${({ lineHeight }) => lineHeight || 1.6};
    }

    /* :has selector 대신 class selector를 사용해 모바일 Safari 계산 비용을 낮춘다. */
    p.ql-image-only-paragraph {
      line-height: 0;
      font-size: 0;
    }

    /* Quill은 BlockEmbed(<hr>) 앞에 커서용 빈 <p>를 항상 DOM에 유지한다.
       출력 페이지에선 나타나지 않으나 에디터에서 빈 줄로 보이므로 시각적으로 숨긴다. */
    p.ql-before-custom-hr {
      height: 0;
      overflow: hidden;
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  ${QuillToolbarStyles}
  ${({ isHtmlMode }) => isHtmlMode && hiddenEditor}
`;
